import './FeatureList.css'

export interface FeatureListProps {
  items: string[]
}

export function FeatureList({ items }: FeatureListProps) {
  return (
    <ul className="azoya-feature-list">
      {items.map((item) => (
        <li key={item} className="azoya-feature-list-item">
          <span className="azoya-feature-list-check">✓</span>
          {item}
        </li>
      ))}
    </ul>
  )
}
